import { UserRound } from "lucide-react";
import { useTranslation } from "react-i18next";

import { Badge } from "@/components/ui/badge";
import { cn } from "@/lib/utils";

import { CareTeamResponse } from "@/types/careTeam/careTeam";
import { formatName } from "@/Utils/utils";

interface EncounterCareTeamBadgesProps {
  care_team: CareTeamResponse[];
  className?: string;
}

export default function EncounterCareTeamBadges({
  care_team,
  className,
}: EncounterCareTeamBadgesProps) {
  const { t } = useTranslation();

  if (!care_team || care_team.length === 0) return null;

  const primary = care_team[0].member;

  if (!primary) return null;

  return (
    <Badge
      variant="sky"
      className={cn(
        "max-w-full gap-1 whitespace-nowrap px-1.5 py-0.5",
        className,
      )}
      title={`${t("care_team")} (${t("primary")}) - ${formatName(primary)}`}
    >
      <UserRound className="size-3 shrink-0" />
      <span className="truncate">
        {t("care_team")} - {formatName(primary)}
      </span>
    </Badge>
  );
}
